import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FULL_ACCESS_DENIED_ROUTE } from '@routes';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  readonly #router = inject(Router);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          void this.#router.navigate([FULL_ACCESS_DENIED_ROUTE], {
            state: {
              checkUser: false,
              sourceUrl: window.location.href,
            },
          });
          return EMPTY;
        }

        return throwError(() => error);
      })
    );
  }
}
